// Connect directory client. Searches other CaddieGames users by name via
// the backend (GET /caddiegames/users/search) so a roster entry can be
// linked to a real user. Only the public profile fields come back — name,
// home course, handicap index — never contact details.

export interface DirectoryUser {
  userId: string;
  name: string;
  homeCourse?: string | null;
  handicapIndex?: number | null;
}

const SEARCH_URL = `${process.env.REACT_APP_BACKEND_URL}/caddiegames/users/search`;

// Returns matching users, or [] on any failure (network, auth, empty
// query). Callers debounce; this stays a thin fetch with no caching so a
// freshly-set profile shows up on the next search.
export async function searchDirectory(query: string): Promise<DirectoryUser[]> {
  const q = query.trim();
  if (q.length < 2) return [];
  try {
    const res = await fetch(`${SEARCH_URL}?q=${encodeURIComponent(q)}`, {
      credentials: "include",
    });
    if (!res.ok) return [];
    const body = await res.json();
    return Array.isArray(body.users) ? (body.users as DirectoryUser[]) : [];
  } catch {
    return [];
  }
}
